import { render, staticRenderFns } from "./CustomerFormCustomerContacts.vue?vue&type=template&id=f769b7f6&scoped=true&"
import script from "./CustomerFormCustomerContacts.vue?vue&type=script&lang=ts&"
export * from "./CustomerFormCustomerContacts.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerFormCustomerContacts.vue?vue&type=style&index=0&id=f769b7f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f769b7f6",
  null
  
)

export default component.exports